import  { useEffect } from "react";
import { Switch, useLocation } from "wouter";
import CampaingDetailProfileAndProduct from "./Pages/CampaingDetailProfileAndProduct/CampaingDetailProfileAndProduct";
import CreateCampaing from "./Pages/CreateCampaing/CreateCampaing";
import CreateProduct from "./Pages/CreateProduct/CreateProduct";
import EditCampaing from "./Pages/EditCampaing/EditCampaing";
import Home from "./Pages/Home/Home";
import Login from "./Pages/Login/Login";
import ManageProducts from "./Pages/ManageProducts/ManageProducts";
import Protected from "./Routes/Protected";
import Public from "./Routes/Public";
import CreateProfileAndRole from "./Pages/CreateProfileAndRole/CreateProfileAndRole";
import ManageCampaigns from "./Pages/ManageCampaigns/ManageCampaigns";
import ManageRoles from "./Pages/ManageRoles/ManageRoles";
import AccountInformation from "./Pages/AccountInformation/AccountInformation";
import ManageRolesFormEdit from "./Pages/ManageRolesFormEdit/ManageRolesFormEdit";
import PageNotFound from "./Pages/PageNotFound/PageNotFound";
import CreateCategory from "./Pages/CreateCategory/CreateCategory";
import ManageCategories from "./Pages/ManageCategories/ManageCategories";
import EditCategory from "./Pages/EditCategory/EditCategory";

const AppRouter = () => {
  const [location] = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // Cada vez que ingrese a una Page el scroll sube al top
  }, [location]);

	return (
		<Switch>
    	<Public path="/" exact component={Login} />
      
			<Protected path="/dashboard" component={Home} />

			<Protected path="/perfiles-roles/informacion-de-cuenta" component={AccountInformation} />
			<Protected path="/perfiles-roles/crear" component={CreateProfileAndRole} />
      <Protected path="/perfiles-roles/gestionar" component={ManageRoles} />
			<Protected path="/perfiles-roles/editar" component={ManageRolesFormEdit} />

			<Protected path="/campaigns/crear" component={CreateCampaing} />
			<Protected path="/campaigns/gestionar" component={ManageCampaigns} />
			<Protected path="/campaigns/gestionar/editar" component={EditCampaing} />
			<Protected path="/campaigns/gestionar/editar/perfiles" component={CampaingDetailProfileAndProduct} />  {/* En proceso */}
      
			<Protected path="/productos/gestionar" component={ManageProducts} />
			<Protected path="/productos/crear" component={CreateProduct} /> 
			<Protected path="/productos/categorias/crear" component={CreateCategory} /> 
			<Protected path="/productos/categorias/gestionar" component={ManageCategories} /> 
			<Protected path="/productos/categorias/editar/:id" component={EditCategory} /> 

      <Protected component={PageNotFound} /> 
		</Switch>
	);
};

export default AppRouter;
